import React from "react";
import "../css/solution.classification.css";

const SolutionClassification = ({ activeSolutionData }) => {
  // Helper function to safely render array or string data
  const renderItems = (data, className) => {
    if (!data) return null;

    if (Array.isArray(data)) {
      return data.map((item, index) => {
        return (
          <>
            <span key={index} className={className}>
              {item}
            </span>
            <strong style={{ color: "var(--db-secondary-gray-ten)" }}>{index < data.length - 1 && " |"}</strong>
          </>
        );
      });
    }

    if (typeof data === "string") {
      return data.split(",").map((item, index) => (
        <span key={index} className={className}>
          {item.trim()}
        </span>
      ));
    }

    return null;
  };

  // Get industry/sector data
  const getIndustryData = () => {
    // Check multiple possible locations for industry data
    const industryInfo =
      activeSolutionData?.solution_metadata?.a2a?.industry_info ||
      activeSolutionData?.solution_metadata?.industry_info ||
      activeSolutionData?.industry_info;

    if (!industryInfo || !Array.isArray(industryInfo)) {
      return [];
    }

    // Transform the data to match the expected format
    return industryInfo.map((item) => ({
      name: item.industry,
      sectors: item.sector || [],
    }));
  };

  const getBusinessFunctionData = () => {
    const businessFunctionData =
      activeSolutionData?.solution_metadata?.a2a?.business_function ||
      activeSolutionData?.solution_metadata?.business_function ||
      activeSolutionData?.business_function ||
      activeSolutionData?.function;

    return businessFunctionData;
  };

  return (
    <>
      <div className="solution-classification-container">
        <div className="row mb-3">
          <div className="col-md-12">
            <h3 className="classification-title">Classification</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="classification-details">
              <div className="classification-detail-row mb-3">
                <div className="col-md-3">
                  <span className="detail-label">Industry/Sector</span>
                </div>
                <div className="col-md-9">
                  <div className="industry-values">
                    {(() => {
                      const industries = getIndustryData();
                      return industries.length === 0 ? (
                        <div
                          className="classfication-value"
                          style={{ color: "#63666A" }}
                        >
                          N/A
                        </div>
                      ) : (
                        industries.map((industry, idx) => (
                          <div key={idx} className="industry-item">
                            {industry?.name}
                            {industry?.sectors &&
                              industry.sectors.length > 0 && (
                                <> | {industry.sectors.join(", ")}</>
                              )}
                          </div>
                        ))
                      );
                    })()}
                  </div>
                </div>
              </div>
              <div className="classification-detail-row">
                <div className="col-md-3">
                  <span className="detail-label">Business Function</span>
                </div>
                <div className="col-md-9">
                  <div className="business-function-values">
                    {getBusinessFunctionData() ? (
                      renderItems(
                        getBusinessFunctionData(),
                        "business-function-item"
                      )
                    ) : (
                      <span className="business-function-item">
                        No business function data available
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SolutionClassification;
